/*
 * Carrusel de upsell "Complete the look" del cajon de carrito.
 *
 * Marcado: snippets/cart-drawer-complete-look.liquid
 * Estilos: <style> inline dentro de ese mismo snippet
 *
 * Por que este archivo existe en vez de un <script> dentro del snippet:
 * cart-drawer.js reemplaza el innerHTML de #CartDrawer entero en cada
 * actualizacion del carrito, y un <script> insertado por innerHTML NO se
 * ejecuta. Cualquier logica que viviera dentro del cajon quedaria muerta tras
 * el primer add-to-cart. Este archivo se carga una sola vez desde la cabecera
 * de snippets/cart-drawer.liquid (fuera de #CartDrawer) y se engancha por
 * DELEGACION en document: los listeners sobreviven a todos los re-renders
 * porque nunca estuvieron atados a los nodos que se destruyen.
 *
 * Misma razon para no cachear referencias: cada handler resuelve su tarjeta
 * desde el evento en el momento del clic.
 */
(function () {
  'use strict';

  // El archivo va con defer y ademas se referencia una sola vez, pero el guard
  // hace idempotente cualquier doble inclusion (apps, ediciones del tema).
  if (window.completeLookCarouselLoaded) return;
  window.completeLookCarouselLoaded = true;

  var SELECTOR = {
    root: '[data-complete-look]',
    track: '[data-complete-look-track]',
    card: '[data-complete-look-card]',
    select: '[data-complete-look-select]',
    add: '[data-complete-look-add]',
    error: '[data-complete-look-error]',
    priceNow: '[data-complete-look-price-now]',
    priceWas: '[data-complete-look-price-was]',
    nav: '.complete-look__nav',
    prev: '.complete-look__prev',
    next: '.complete-look__next'
  };

  // Se piden las dos secciones en la MISMA peticion de /cart/add.js: una sola
  // ida y vuelta en vez de add + section_id por separado.
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  /* ---------------------------------------------------------------------
     Flechas
     --------------------------------------------------------------------- */

  function syncArrows(root) {
    var track = root.querySelector(SELECTOR.track);
    var prev = root.querySelector(SELECTOR.prev);
    var next = root.querySelector(SELECTOR.next);
    if (!track || (!prev && !next)) return;

    // 1px de tolerancia: los navegadores devuelven scrollLeft fraccionario con
    // zoom o densidades no enteras y el boton se quedaria activo en el extremo.
    var max = track.scrollWidth - track.clientWidth;
    var position = track.scrollLeft;

    if (prev) prev.disabled = position <= 1;
    if (next) next.disabled = position >= max - 1;
  }

  function syncAll() {
    var roots = document.querySelectorAll(SELECTOR.root);
    for (var i = 0; i < roots.length; i++) syncArrows(roots[i]);
  }

  var syncQueued = false;

  function scheduleSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(function () {
      syncQueued = false;
      syncAll();
    });
  }

  function handleNav(button) {
    var root = button.closest(SELECTOR.root);
    var track = root && root.querySelector(SELECTOR.track);
    if (!track) return;

    var direction = button.classList.contains('complete-look__prev') ? -1 : 1;

    track.scrollBy({
      left: direction * track.offsetWidth,
      behavior: reducedMotion() ? 'auto' : 'smooth'
    });
  }

  /* ---------------------------------------------------------------------
     Desplegable de variante
     --------------------------------------------------------------------- */

  function syncVariant(select) {
    var card = select.closest(SELECTOR.card);
    if (!card) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var now = card.querySelector(SELECTOR.priceNow);
    var was = card.querySelector(SELECTOR.priceWas);
    var add = card.querySelector(SELECTOR.add);

    if (now && option.dataset.price) now.textContent = option.dataset.price;

    if (was) {
      if (option.dataset.compare) {
        was.textContent = option.dataset.compare;
        was.hidden = false;
      } else {
        was.hidden = true;
      }
    }

    // El boton guarda su propio id como respaldo por si el <select> esta oculto
    // (producto de variante unica) o deshabilitado.
    if (add) add.dataset.variantId = select.value;
  }

  /* ---------------------------------------------------------------------
     Alta en carrito
     --------------------------------------------------------------------- */

  function setBusy(button, busy) {
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    button.disabled = !!busy;
  }

  // Camino principal: cart-drawer.js ya sabe repintar el cajon con las
  // secciones que devuelve /cart/add.js, y de paso reabre el cajon, refresca
  // la burbuja del icono y recoloca la cuenta atras del anuncio.
  //
  // Camino de respaldo: Section Rendering API a pelo, por si el elemento
  // <cart-drawer> no estuviera definido todavia (tipo de carrito cambiado en
  // ajustes, o cart-drawer.js bloqueado por una app).
  function refreshDrawer(payload) {
    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.renderContents === 'function' && payload && payload.sections && payload.sections['cart-drawer']) {
      drawer.renderContents(payload);
      return Promise.resolve();
    }

    return fetch(cartUrl() + '?section_id=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var current = document.getElementById('CartDrawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;

        if (drawer) {
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') drawer.open();
        }

        return fetch(cartUrl() + '?section_id=cart-icon-bubble');
      })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      });
  }

  function handleAdd(button) {
    if (button.getAttribute('aria-busy') === 'true') return;

    var card = button.closest(SELECTOR.card);
    var select = card && card.querySelector(SELECTOR.select);
    var errorEl = card && card.querySelector(SELECTOR.error);
    var variantId = (select && select.value) || button.dataset.variantId;

    if (!variantId) return;
    if (errorEl) errorEl.textContent = '';

    setBusy(button, true);

    fetch(cartAddUrl() + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        // /cart/add.js responde 422 con { status, message, description } cuando
        // la variante se ha agotado entre el render y el clic.
        if (payload && payload.status) {
          throw new Error(payload.description || payload.message || '');
        }
        return refreshDrawer(payload);
      })
      .then(function () {
        // El resto del tema (contadores, apps de envio gratis) escucha este
        // evento. Si pubsub.js no estuviera cargado, no pasa nada.
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-complete-look',
              productVariantId: variantId
            });
          }
        } catch (error) {
          /* el evento es opcional: nunca debe tumbar el alta */
        }
        // No se restaura el estado del boton a proposito: en el camino normal
        // el nodo ya ha sido reemplazado por el re-render del cajon.
      })
      .catch(function (error) {
        setBusy(button, false);
        if (errorEl) {
          errorEl.textContent =
            (error && error.message) || (window.cartStrings && window.cartStrings.error) || '';
        }
      });
  }

  /* ---------------------------------------------------------------------
     Delegacion
     --------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var nav = target.closest(SELECTOR.nav);
    if (nav) {
      handleNav(nav);
      return;
    }

    var add = target.closest(SELECTOR.add);
    if (add) handleAdd(add);
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var select = target.closest(SELECTOR.select);
    if (select) syncVariant(select);
  });

  // scroll no burbujea: se escucha en fase de captura para poder seguir
  // delegando en document en vez de atar un listener a cada track.
  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.matches(SELECTOR.track)) return;
      scheduleSync();
    },
    true
  );

  window.addEventListener('resize', scheduleSync);

  // El cajon se repinta entero por AJAX sin disparar ningun evento propio, asi
  // que el estado inicial de las flechas del marcado nuevo se recalcula
  // observando #CartDrawer. rAF agrupa las mutaciones de un mismo re-render en
  // un solo sync.
  function observe() {
    if (!('MutationObserver' in window)) return;
    var host = document.getElementById('CartDrawer') || document.body;
    new MutationObserver(scheduleSync).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe();
      syncAll();
    });
  } else {
    observe();
    syncAll();
  }
})();
